import { createSelector } from 'reselect'
import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getExperimentEnabledDecision, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { isSpoofed } from 'selectors/isSpoofed'
import { selectIsGuestCheckoutMode } from 'selectors/checkoutSelectors'
export const getCanActivateMobileAppLikeCheckout = createSelector(
  (state: App.State) => state.system?.device?.deviceType === 'mobile',
  (state: App.State) => findPostPurchaseCheckout(state.checkout?.cart?.mode),
  (state: App.State) => isSpoofed(state),
  (state: App.State) => selectIsGuestCheckoutMode(state),
  (isMobileDevice, postPurchaseMode, isSpoofed, isGuestCheckoutMode): boolean => {
    return config.BRAND === 'luxuryescapes' && isMobileDevice && !postPurchaseMode && !isSpoofed && !isGuestCheckoutMode
  },
)

export const getIsMobileAppLikeCheckoutEnabled = createSelector(
  (state: App.State) => getCanActivateMobileAppLikeCheckout(state),
  (state: App.State) => getOptimizelyExperimentVariation(state, Experiments.croMobileWebAppLikeCheckout.id),
  (canActivate, variation): boolean => canActivate && getExperimentEnabledDecision(variation),
)
